export default __webpack_public_path__ + "static/media/watch.8b5a9ea7.csv";